import * as messages from '@radnuc/messages';
import {immerable, produce} from "immer";

export class Dataset {
    [immerable] = true;

    images: Map<number,messages.Contextual.ContextImageReference[]>;
    imageAnalyses: Map<number,messages.Contextual.ContextImageAnalysis[]>;
    track2d: Map<number,messages.Contextual.ContextTrack2DAnalysis[]>;
    track3d: Map<number,messages.Contextual.ContextTrack3DAnalysis[]>;

    positions: messages.Core.GPSReading[];
    radiationReadings: messages.Rad.RadiationReading[];
    neutronReadings: messages.Rad.NeutronReading[];
    pcsResults: messages.Rad.PCSResult[] = [];
    neutronResults: messages.Rad.NeutronResult[] = [];
    attributionAnalysis?: messages.Contextual.SourceAttributionAnalysis;
    attribution?: Map<String,messages.Contextual.SourceAttributionSummary>;

    metReadings?: messages.Chem.MetReading[];
    chemIdResults?: messages.Chem.ChemIdentificationResult[];
    bioLifReadings?: messages.SigmaPlusBio.LIFReading[];

    constructor(
            images: Map<number,messages.Contextual.ContextImageReference[]>,
            imageAnalyses: Map<number,messages.Contextual.ContextImageAnalysis[]>,
            track2d: Map<number,messages.Contextual.ContextTrack2DAnalysis[]>,
            track3d: Map<number,messages.Contextual.ContextTrack3DAnalysis[]>,
            gps: messages.Core.GPSReading[],
            spectra: messages.Rad.RadiationReading[],
            pcs: messages.Rad.PCSResult[],
            neutron: messages.Rad.NeutronReading[],
            neutronResult: messages.Rad.NeutronResult[],
            attributionAnalysis?: messages.Contextual.SourceAttributionAnalysis,
            attribution?: Map<String,messages.Contextual.SourceAttributionSummary>,
            metReadings?: messages.Chem.MetReading[],
            chemIdResults?: messages.Chem.ChemIdentificationResult[],
            bioLifReadings?: messages.SigmaPlusBio.LIFReading[]

        ) {
        this.images = images;
        this.imageAnalyses = imageAnalyses;
        this.track2d = track2d;
        this.track3d = track3d;
        this.positions = gps;
        this.radiationReadings = spectra;
        this.pcsResults = pcs;
        this.neutronReadings = neutron;
        this.neutronResults = neutronResult;
        this.attributionAnalysis = attributionAnalysis;
        this.attribution = attribution;
        this.metReadings = metReadings;
        this.chemIdResults = chemIdResults;
        this.bioLifReadings = bioLifReadings;
    }
}

export function invToEncounter(inv: messages.Rad.Investigation){
    let result = new messages.Encounter.Encounter();
    result.type = messages.Encounter.EncounterType.RAD;
    result.algorithm = inv.algorithm;
    result.background_spectrum = inv.background_spectrum;
    result.end_time = inv.end_time;
    result.finalized = inv.finalized;
    result.id = inv.id;
    result.isotopes = inv.isotopes;
    result.max_count_rate = inv.max_count_rate;
    //result.max_counts = inv.max_counts;
    result.max_dose_rate = inv.max_dose_rate;
    //result.mean_counts = inv.mean_counts;
    result.neutron_background = inv.neutron_background;
    result.relative_bearing_to_source = inv.relative_bearing_to_source;
    result.source_lane = inv.source_lane;
    result.source_lane_position = inv.source_lane_position;
    result.source_location = inv.isotope_location;
    result.start_time = inv.start_time;
    result.user_generated = inv.user_generated;
    result.vehicle_heading = inv.vehicle_heading;
    result.vehicle_location = inv.vehicle_location;
    result.suppressed = inv.suppressed;

    return result;
}

export function encounterToInv(enc: messages.Encounter.Encounter){
    if(enc.type === messages.Encounter.EncounterType.RAD){
        let result = new messages.Rad.Investigation();
        result.algorithm = enc.algorithm;
        result.background_spectrum = enc.background_spectrum;
        result.end_time = enc.end_time;
        result.finalized = enc.finalized;
        result.id = enc.id;
        result.isotopes = enc.isotopes;
        result.max_count_rate = enc.max_count_rate;
        result.max_dose_rate = enc.max_dose_rate;
        result.neutron_background = enc.neutron_background;
        result.relative_bearing_to_source = enc.relative_bearing_to_source;
        result.source_lane = enc.source_lane;
        result.source_lane_position = enc.source_lane_position;
        result.isotope_location = enc.source_location;
        result.start_time = enc.start_time;
        result.user_generated = enc.user_generated;
        result.vehicle_heading = enc.vehicle_heading;
        result.vehicle_location = enc.vehicle_location;
        result.suppressed = enc.suppressed;
        return result;
    } else {
        return undefined
    }
}

export default Dataset
